import { styled, disabledProps } from "../../../styled-components";
import { css } from "styled-components";

export const ExpandableOptionsContainer = styled.div`
    position: relative;

    height: 58px;
    padding: ${p => p.theme.componentSmallInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    line-height: 1.2em;
`;

export const LeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const SelectedOptionButton = styled.div<{ open: boolean }>`
    ${p =>
        p.open
            ? css`
                  display: flex;
                  justify-content: center;
                  align-items: center;
              `
            : css`
                  display: none;
              `}

    width: 40px;
    height: 40px;
    border-radius: 100px;

    & > .emoji {
        font-size: 30px;
    }
`;

const openProps = css`
    display: flex;
    pointer-events: unset;
    opacity: 1;
    transition: opacity 0.5s ease, flex 0.3s ease-out;
`;

const closedProps = css`
    pointer-events: none;
    flex: 0;
    opacity: 0;
    transition: opacity 0.3s ease, flex 0s ease-out 0.3s;
`;

export const OptionsModal = styled.div<{ open: boolean }>`
    position: absolute;
    bottom: 6px;

    ${p => (p.open ? openProps : closedProps)}

    justify-items: center;
    align-items: center;
    right: 16px;

    display: flex;

    height: 48px;
    padding: 4px;
    border-radius: 40px;

    background-color: ${p => p.theme.expandableOptions.modal.bgColor};
    box-shadow: 0px 10px 42px rgba(0, 0, 0, 0.2);

    cursor: default;

    & > .icon {
        min-width: 40px;
        min-height: 40px;
        margin-right: 4px;
    }

    & > .emoji {
        margin-right: 4px;
        padding: 12px 5px;
        font-size: 30px;
    }

    & > div:not(.close):hover,
    & > .selected {
        border-radius: 100px;
        background-color: ${p => p.theme.expandableOptions.options.bgColorSelected};

        svg {
            color: ${p => p.theme.expandableOptions.options.fgColorSelected};
        }
    }

    & svg {
        color: ${p => p.theme.expandableOptions.options.bgColorSelected};
    }

    & .close {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 24px;
        height: 24px;
        margin: 0px 8px 0px 4px;

        background-color: ${p => p.theme.expandableOptions.options.bgColorUnselected};
        border-radius: 100px;
    }
`;

export const RightContainer = styled.div<{ selected?: boolean, disabled?: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${p => p.disabled && disabledProps}

    & ${SelectedOptionButton} {
        background-color: ${p =>
            p.selected
                ? p.theme.expandableOptions.button.bgColorSelected
                : p.theme.expandableOptions.button.bgColorUnselected};
        color: ${p =>
            p.selected
                ? p.theme.expandableOptions.button.fgColorSelected
                : p.theme.expandableOptions.button.fgColorUnselected};

        & > .emoji {
            cursor: default;
            ${p =>
                !p.selected &&
                css`
                    filter: grayscale(100%);
                    opacity: 0.6;
                `};
        }
    }
`;

export const Caption = styled.div`
    color: ${p => p.theme.fgColorLight};
    margin-bottom: 4px;
`;

export const Value = styled.div`
    color: ${p => p.theme.fgColorDark};
    ${p => p.theme.fontStyles.AccentCallout4}
`;
